var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74594 4.10363H0.302548C0.161039 4.10363 0.0667105 4.00934 0.0195407 3.915C-0.027629 3.82066 0.0195292 3.67911 0.066699 3.58477L3.51009 0.141415C3.60443 0.0470752 3.74594 0.0470292 3.84028 0.0941989C3.93462 0.141369 4.02897 0.235754 4.02897 0.377264V3.82062C4.07614 3.96213 3.93462 4.10363 3.74594 4.10363ZM1.05725 3.49046H3.46293V1.08481L1.05725 3.49046Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.878 20H0.302538C0.113859 20 0.0195312 19.8585 0.0195312 19.717V3.77358C0.0195312 3.67924 0.066678 3.63207 0.113848 3.53773L3.55727 0.0943165C3.60443 0.0471468 3.69877 0 3.79311 0H14.9252C15.1139 0 15.2082 0.141498 15.2082 0.283007V19.6698C15.161 19.9056 15.0195 20 14.878 20ZM0.632733 19.4339H14.595V0.660388H3.93462L0.679891 3.91512V19.4339H0.632733Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2366 6.46225H5.68001C5.49133 6.46225 5.39697 6.32076 5.39697 6.17925C5.39697 5.99057 5.5385 5.89624 5.68001 5.89624H12.2366C12.4253 5.89624 12.5196 6.03774 12.5196 6.17925C12.5668 6.32076 12.4253 6.46225 12.2366 6.46225Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2366 9.90561H2.94414C2.75546 9.90561 2.66113 9.76412 2.66113 9.62261C2.66113 9.43393 2.80263 9.3396 2.94414 9.3396H12.2366C12.4253 9.3396 12.5196 9.4811 12.5196 9.62261C12.5668 9.81129 12.4253 9.90561 12.2366 9.90561Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2366 13.3962H2.94414C2.75546 13.3962 2.66113 13.2547 2.66113 13.1131C2.66113 12.9716 2.80263 12.8301 2.94414 12.8301H12.2366C12.4253 12.8301 12.5196 12.9716 12.5196 13.1131C12.5196 13.2547 12.4253 13.3962 12.2366 13.3962Z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88755 16.8397H2.94414C2.75546 16.8397 2.66113 16.6982 2.66113 16.5567C2.66113 16.4152 2.80263 16.2737 2.94414 16.2737H8.88755C9.07623 16.2737 9.17056 16.4152 9.17056 16.5567C9.17056 16.6982 9.02906 16.8397 8.88755 16.8397Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.506505369e2e393f822d7d5399d41a20.svg";
export { ForwardRef as ReactComponent };